import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDirective } from 'angular-bootstrap-md';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Clothes } from 'src/app/models/Clothes';
import { NocSizes } from 'src/app/models/NocSizes';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ClothesService } from 'src/app/services/clothes.service';
import { RouteService } from 'src/app/services/routeService';
import { CONSTANTES, getToken } from 'src/app/shared/global';

declare var jQuery: any;

@Component({
  selector: 'app-noc-sizes',
  templateUrl: './noc-sizes.component.html',
  styleUrls: ['./noc-sizes.component.scss']
})
export class NocSizesComponent implements OnInit {
  listNocSizes: NocSizes[] = [];
  titulos: String[] = ['TALLA', 'NOC', 'CODIGO INTERNO', 'NPC'];
  nocSizes : NocSizes[] = [];
  clothCode: string;
  item: Clothes= new Clothes();
  form: FormGroup;
  nocSizeData: NocSizes = new NocSizes();
  selectEdit: String;
  indexSelect: number = 0;
  action: String;
  selectNoc : string = null;
  selectNpc : string = null;
  selectInternalCode : string = null;
  @ViewChild('nocSizeModal') nocSizeModal: ModalDirective;

  constructor(private route:ActivatedRoute ,private spinner: NgxSpinnerService, private toastr: ToastrService, private clothesService: ClothesService,private authService: AuthenticationService,
     private router: Router, private SpinnerService: NgxSpinnerService, private routeService: RouteService) { }

  ngOnInit() {
    this.SpinnerService.show();
    this.route.paramMap.subscribe(params => {
      this.clothCode = params.get('code');
    });
    //localStorage.removeItem("item");
    this.getItem();
    
    if(this.item.nocSizes == null || this.item.nocSizes.length == 0) {
      this.initNocSizes();
    }
    try{
      jQuery.getScript(CONSTANTES.menu);
    } catch(Error){
      this.router.navigate(['login']);
    }
    
    this.form = new FormGroup({
      'name': new FormControl('', Validators.required),
      'size': new FormControl('', Validators.required),
      'noc': new FormControl('', Validators.required),
      'internalCode': new FormControl('', Validators.required), 
      'npc': new FormControl('', Validators.required),
      'temporaryName': new FormControl('', Validators.required),
      'finalName': new FormControl('', Validators.required),
    });
  }

  initNocSizes() {
    let aux: NocSizes = new NocSizes();
    aux.size = "S/T";
    this.nocSizes.push(aux);
    this.item.nocSizes = this.nocSizes
  }

  /*Cambia los nombres del articulo*/
  editNames(){
    this.clothesService.saveClothes(this.item).subscribe(
      data => {
        if (getToken(data)) {
          this.toastr.info("DATOS CORRECTAMENTE ACTUALIZADOS", "INFO");
        }
      },
      error => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL GUARDAR LOS DATOS", "ERROR");
      }  
    )
    this.spinner.hide();
  }
  
  /**Metodo que rellena campos al seleccionar prenda */
  async getItem() {
   /* let code: string = this.item.name;
     this.clothes.forEach(element => {
      if (element.code == code) {
        return this.item = element;
      }
    }); */
    this.item = await this.clothesService.getClothByCode(this.clothCode).toPromise();
    this.spinner.hide();
  }

  /**Metodo que edita los campos de la tabla */
  edit(index: number) {
    this.action = "Editar";
    this.createData(index);
    this.indexSelect = index;
    this.nocSizeModal.show();
  }

  /**Método que se encarga de crear o cargar la información en el modal para insertar o editar*/
  createData(index: number) {
    this.selectEdit = null;
    if (this.action === "Editar") {
      this.nocSizeData.size = this.item.nocSizes[index].size.toString();
      this.selectNoc = this.item.nocSizes[index].noc;
      this.selectNpc = this.item.nocSizes[index].npc;
      this.selectInternalCode = this.item.nocSizes[index].internalCode;
    }
  }

  /**Método que se encarga de insertar registros*/
  insertData(){
    this.item.nocSizes[this.indexSelect].modifiedNoc = false;
    this.item.nocSizes[this.indexSelect].modifiedCode = false;
    if(this.item.nocSizes[this.indexSelect].noc != this.selectNoc){
      this.item.nocSizes[this.indexSelect].noc = this.selectNoc;
      this.item.nocSizes[this.indexSelect].modifiedNoc = true;
    }
    this.item.nocSizes[this.indexSelect].npc = this.selectNpc;
    if(this.item.nocSizes[this.indexSelect].internalCode != this.selectInternalCode){
      this.item.nocSizes[this.indexSelect].internalCode = this.selectInternalCode;
      this.item.nocSizes[this.indexSelect].modifiedCode = true;
    }
    

    if(this.item.nocSizes[this.indexSelect].noc == "")
    this.item.nocSizes[this.indexSelect].noc = null;

    if(this.item.nocSizes[this.indexSelect].internalCode == "")
      this.item.nocSizes[this.indexSelect].internalCode = null;

    if(this.item.nocSizes[this.indexSelect].npc == "")
    this.item.nocSizes[this.indexSelect].npc = null;
      this.clothesService.saveNocs(this.item).subscribe(
        data => {
          if (getToken(data)) {
            this.nocSizeModal.hide();
            this.toastr.info("DATOS CORRECTAMENTE ACTUALIZADOS", "INFO");
          } else {
            if (data.errorCode.code === "E_DATA_ERROR") {
              this.toastr.warning(data.errorCode.message);
            } else {
              this.toastr.error(data.errorCode.message);
            }
          }
        },
        error => {
          this.spinner.hide();
          this.toastr.error("HA OCURRIDO UN ERROR AL GUARDAR LOS DATOS", "ERROR");
        }  
      )
      this.spinner.hide();

  }

  /**Método que se encarga de cerrar y liberar la memoria del modal*/
  closeModal(){
    this.nocSizeModal.hide();
    this.nocSizeModal.ngOnDestroy();
    this.getItem()
  }

  logOut() {
    let infoUser = {
      userName: localStorage.getItem("nid")
    }
    this.authService.logOut(infoUser).subscribe(
      data => {
        localStorage.clear();
        this.router.navigate(['login']);
      }
    );
  }

}
